import { render } from "./WhoAreWe.vue?vue&type=template&id=f6142ecc&scoped=true"
import script from "./WhoAreWe.vue?vue&type=script&lang=js"
export * from "./WhoAreWe.vue?vue&type=script&lang=js"

import "./WhoAreWe.vue?vue&type=style&index=0&id=f6142ecc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6142ecc"]])

export default __exports__